<div cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)" class="example-list ms-10">
  <div cdkDrag cdkDragLockAxis="x" cdkDragBoundary=".example-list" *ngFor="let item of slideButtonItems;let i=index" [cdkDragDisabled]="item.class!=='start'"
    class="example-box" [ngClass]="item.class">
    {{item.text}}
  </div>
</div>
